export default __webpack_public_path__ + "static/media/cp.b9128a12.png";